import { motion } from 'framer-motion'
import style from './circle-bg.module.scss'

export const ImgBg = ({ className }) => {
  const Circle1Variants = {
    visible: {
      scale: 1.1,
      rotate: 15,
      transition: {
        repeat: Infinity,
        duration: 10,
        repeatType: 'reverse',
        type: 'just',
      },
    },
    hidden: {
      scale: 1,
      rotate: 0,
      transition: { repeat: Infinity, duration: 5 },
    },
    initial: {
      scale: 1,
      rotate: 0,
      transition: { repeat: Infinity, delay: 0.15 },
    },
  }
  const Circle2Variants = {
    visible: {
      scale: 1.1,
      rotate: -15,
      transition: {
        repeat: Infinity,
        duration: 10,
        repeatType: 'reverse',
        type: 'just',
      },
    },
    hidden: {
      scale: 1,
      rotate: 0,
      transition: { repeat: Infinity, duration: 5 },
    },
    initial: {
      scale: 1,
      rotate: 0,
      transition: { repeat: Infinity, delay: 0.15 },
    },
  }

  const variantsImgBg = {
    visible: {
      opacity: 1,
      translateY: 0,
      translateX: 0,
      transition: { duration: 0.4, delay: 0.15 },
    },
    hidden: {
      opacity: 0,
      translateY: 16,
      translateX: -16,
      transition: { repeat: Infinity, delay: 0.15 },
    },
  }

  return (
    <motion.svg
      className={className}
      variants={variantsImgBg}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.25, once: true }}
      fill="none"
      viewBox="0 0 1164 1164"
      alt="about-main-bg"
    >
      <motion.g
        className={style.circleAbout}
        variants={Circle1Variants}
        initial="initial"
        exit="hidden"
        animate="visible"
        id="rotatingGroup1"
      >
        <path
          d="M343.908 117.161C162.248 204.385 36.5801 389.816 35.9281 604.845C35.7251 671.88 47.6881 736.111 69.7411 795.449"
          stroke="url(#paint0_linear_3_42)"
          strokeWidth="68"
        />
        <path
          d="M344.408 116.921C415.739 82.761 495.684 63.736 580.07 63.991C802.528 64.666 993.308 199.144 1076.44 390.998"
          stroke="url(#paint1_linear_3_42)"
          strokeWidth="125"
        />
      </motion.g>
      <motion.g
        className={style.circleAbout}
        variants={Circle2Variants}
        initial="initial"
        exit="hidden"
        animate="visible"
        id="rotatingGroup2"
      >
        <path
          d="M337.563 420.488C320.7 445.864 307.519 474.309 298.978 505.281C264.477 630.39 316.113 758.914 418.045 827.717"
          stroke="url(#paint2_linear_3_42)"
          strokeWidth="124"
        />
        <path
          d="M418.045 827.717C443.861 845.142 472.903 858.737 504.589 867.475C626.091 900.981 750.813 853.246 820.926 757.099"
          stroke="url(#paint3_linear_3_42)"
          strokeWidth="70"
        />
        <path
          d="M336.407 422.244C404.608 317.994 534.638 264.776 661.173 299.67C817.968 342.909 910.024 505.069 866.785 661.864C857.152 696.794 841.618 728.511 821.555 756.236"
          stroke="url(#paint4_linear_3_42)"
          strokeWidth="172"
        />
      </motion.g>
      <motion.g
        className={style.circleAbout}
        variants={Circle1Variants}
        initial="initial"
        exit="hidden"
        animate="visible"
        id="rotatingGroup3"
      >
        <path
          d="M674.197 563.765C672.343 554.125 668.955 544.845 664.161 536.279C644.292 500.695 604.232 483.437 566.023 490.661"
          stroke="url(#paint5_linear_3_42)"
          strokeWidth="55"
        />
        <path
          d="M566.179 490.94C556.653 492.734 547.246 496.076 538.31 501.065C504.044 520.198 486.765 557.94 492.153 594.435"
          stroke="url(#paint6_linear_3_42)"
          strokeWidth="21"
        />
        <path
          d="M674.226 563.385C681.863 601.485 664.52 641.835 628.641 661.868C584.183 686.692 528.099 670.921 503.375 626.641C497.867 616.777 494.38 606.33 492.779 595.775"
          stroke="url(#paint7_linear_3_42)"
          strokeWidth="86"
        />
      </motion.g>
      <defs>
        <linearGradient
          id="paint0_linear_3_42"
          x1="-31.7759"
          y1="837.141"
          x2="527.69"
          y2="307.646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3_42"
          x1="433.032"
          y1="98.228"
          x2="453.63"
          y2="420.312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3_42"
          x1="336.28"
          y1="461.159"
          x2="337.428"
          y2="816.425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3_42"
          x1="393.286"
          y1="915.618"
          x2="512.286"
          y2="1064.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3_42"
          x1="446.501"
          y1="284.404"
          x2="381.9"
          y2="671.943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3_42"
          x1="665.496"
          y1="554.399"
          x2="587.023"
          y2="475.007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3_42"
          x1="577.429"
          y1="539.617"
          x2="545.068"
          y2="490.911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3_42"
          x1="679.88"
          y1="618.134"
          x2="609.425"
          y2="517.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
      </defs>
    </motion.svg>
  )
}
